/**
 * NameSaver
 *
 * Service to save (and retrieve) users' domain names
 * to localStorage.
 */

export default class NameSaver {

  names: string[] = []

  constructor(private key: string) {
    this.names = JSON.parse(localStorage.getItem(key) || '[]')
  }

  add(name: string) {
    this.names.push(name)
    setTimeout(this.save, 0)
  }

  remove(name: string) {
    this.names = this.names.filter(n => n != name)
    setTimeout(this.save, 0)
  }

  private save = () => {
    localStorage.setItem(this.key, JSON.stringify(this.names))
  }

}


// WEBPACK FOOTER //
// ./src/service/name-saver.ts